var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 0L27 10.6667V28.2667C27 30.3285 25.3076 32 23.22 32H3.78C1.69236 32 0 30.3285 0 28.2667V3.73333C0 1.67147 1.69236 0 3.78 0H16.2Z",
    fill: "#E94848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.667H20.1709C18.0833 10.667 16.2 8.80696 16.2 6.7451V0.000325203L27 10.667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77972 21.9439C9.09718 21.9439 8.55025 22.2877 8.26097 22.81H8.24289V22.0243H7.49707V28.2162H8.28357V25.9127H8.30165C8.58189 26.4216 9.1243 26.7475 9.7978 26.7475C10.9821 26.7475 11.7912 25.8011 11.7912 24.3457C11.7912 22.8903 10.9775 21.9439 9.77972 21.9439ZM9.62603 26.0645C8.82146 26.0645 8.27905 25.3814 8.27905 24.3457C8.27905 23.3145 8.82146 22.627 9.62603 22.627C10.4622 22.627 10.9866 23.2966 10.9866 24.3457C10.9866 25.3993 10.4622 26.0645 9.62603 26.0645Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3676 26.7475C15.0456 26.7475 15.5835 26.4171 15.8864 25.8814H15.8999V26.6671H16.6503V20.2252H15.8638V22.7787H15.8457C15.5654 22.2698 15.023 21.9439 14.3495 21.9439C13.1653 21.9439 12.3562 22.8903 12.3562 24.3457C12.3562 25.8011 13.1698 26.7475 14.3676 26.7475ZM14.5168 22.627C15.3259 22.627 15.8683 23.31 15.8683 24.3457C15.8683 25.3859 15.3259 26.0645 14.5168 26.0645C13.6851 26.0645 13.1607 25.3993 13.1607 24.3457C13.1607 23.2966 13.6851 22.627 14.5168 22.627Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9656 26.6671H18.7521V22.6627H19.7104V22.0243H18.7476V21.5109C18.7476 21.0511 18.951 20.8278 19.3759 20.8278C19.5069 20.8278 19.638 20.8412 19.733 20.8546V20.2252C19.62 20.2073 19.4301 20.1895 19.2538 20.1895C18.386 20.1895 17.9656 20.6136 17.9656 21.5064V22.0243H17.3102V22.6627H17.9656V26.6671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b1a317a4ce248dfe75952d036baccd5f.svg";
export { ForwardRef as ReactComponent };